import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { environment } from "../../environments/environment";
import { promise } from 'protractor';
import * as Oidc from 'oidc-client';


export { User };

@Injectable({
  providedIn: 'root'
})
export class AppAuthNService {

  _userManager: UserManager;

  constructor() {
    var settings = {
      authority: environment.STSSettings.stsAuthority,
      client_id: environment.STSSettings.clientId,
      redirect_uri: `${environment.STSSettings.clientRoot}/assets/sts/signin-callback.html`,
      silent_redirect_uri: `${environment.STSSettings.clientRoot}/assets/sts/silent-callback.html`,
      post_logout_redirect_uri: `${environment.STSSettings.clientRoot}`,
      response_type: 'id_token token',
      scope: environment.STSSettings.clientScope,
      userStore: new Oidc.WebStorageStateStore({ store: window.localStorage })
    };
    this._userManager = new UserManager(settings);
  }

  public getUser(): Promise<User> {
    return this._userManager.getUser();
  }

  public login(): Promise<void> {
    return this._userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this._userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this._userManager.signoutRedirect();
  }


}
